if (!customElements.get('collection-seo-link')) {
  customElements.define(
    'collection-seo-link',
    class CollectionSeoLink extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a[href^="#"]');
        if (!this.link) return;

        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick, true);
      }

      handleClick(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const target = document.querySelector(this.link.hash);
        if (!target) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const hadTabIndex = target.hasAttribute('tabindex');

        if (!hadTabIndex) target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
        target.scrollIntoView({behavior, block: 'start'});
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${this.link.hash}`);

        if (!hadTabIndex) {
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once: true});
        }
      }
    }
  );
}
